import {ModuleConfigs} from "./types";

export const MODULE_CONFIGS_SET = "moduleConfigs/set";

export const setModuleConfigs = (moduleConfigs: ModuleConfigs) => ({
  type: MODULE_CONFIGS_SET,
  payload: {
    moduleConfigs: moduleConfigs
  }
});
